import {
    ApplicationConfig,
    ErrorHandler,
    provideBrowserGlobalErrorListeners,
    provideZonelessChangeDetection,
} from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './routing/app.routes';
import { configureAmplify } from './core/authentication/amplify';
import { injectTokensFromHash } from './core/authentication/token-bridge';
import { GlobalErrorHandler } from './core/global-error.handler';

injectTokensFromHash();
configureAmplify();

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(routes),
        provideHttpClient(),
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
    ],
};
